export default __webpack_public_path__ + "static/media/otp.0680db1e.svg";